import React from 'react';
import ReactQuill from 'react-quill-new';

import 'react-quill-new/dist/quill.snow.css';

function TmoEditor({ initialValue, onChange }) {
  const handleChange = value => {
    onChange(value);
  };
  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link']
    ]
  };
  const formats = ['bold', 'italic', 'underline', 'list', 'bullet', 'link'];

  return (
    <>
      <ReactQuill
        onChange={handleChange}
        modules={modules}
        formats={formats}
        defaultValue={initialValue}
      />
    </>
  );
}
export default TmoEditor;
